import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { Card, EmptyState, PageBody, Spinner } from '@wundo/ui';
import { ApiError } from '@wundo/client/api.ts';
import { PageHeader } from '@/components/PageHeader.tsx';
import { CohortForm } from '@/components/cohorts/CohortForm.tsx';
import { fetchCohort } from '@/lib/cohorts.ts';
import { useRecordOrganisation } from '@/lib/recordOrganisation.ts';

export const Route = createFileRoute('/_app/cohorts/$id/edit')({
  staticData: { orgScope: 'record', orgScopeList: '/cohorts' },
  component: EditCohortRoute,
});

function EditCohortRoute() {
  return <EditCohortPage id={Route.useParams().id} />;
}

export function EditCohortPage({ id }: { id: string }) {
  const {
    data: cohort,
    isPending,
    error,
  } = useQuery({
    queryKey: ['cohorts', 'detail', id],
    queryFn: () => fetchCohort(id),
    retry: false,
  });
  useRecordOrganisation(cohort?.organisation_id);

  if (isPending) {
    return (
      <PageBody className='flex justify-center'>
        <Spinner />
      </PageBody>
    );
  }

  if (error) {
    /* A cohort that is not there is a state, not a failure. Anything else is. */
    if (!(error instanceof ApiError) || error.status !== 404) throw error;

    return (
      <>
        <PageHeader title='Cohort' />
        <PageBody>
          <Card>
            <EmptyState
              title='Cohort not found'
              description='It may have been deleted.'
            />
          </Card>
        </PageBody>
      </>
    );
  }

  return <CohortForm cohort={cohort} organisationId={cohort.organisation_id} />;
}
